"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DATA_TEST_ID: true
};
exports.DATA_TEST_ID = void 0;
var _detailSizes = require("./detailSizes");
Object.keys(_detailSizes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _detailSizes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _detailSizes[key];
    }
  });
});
var _feature = require("./feature");
Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _feature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _feature[key];
    }
  });
});
var _gallerySizes = require("./gallerySizes");
Object.keys(_gallerySizes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _gallerySizes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _gallerySizes[key];
    }
  });
});
var _vkMarkets = require("./vkMarkets");
Object.keys(_vkMarkets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _vkMarkets[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _vkMarkets[key];
    }
  });
});
var _theme = require("./theme");
Object.keys(_theme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _theme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _theme[key];
    }
  });
});
var _swrConfig = require("./swrConfig");
Object.keys(_swrConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _swrConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _swrConfig[key];
    }
  });
});
const DATA_TEST_ID = exports.DATA_TEST_ID = 'data-testid';
